import { useUserStore } from '../stores/userStore';
import { formatDateTime as dfFormatter, formatDateTimePassed as passedTimeFormatter } from '../utils/formatting';
import { defaultDateFormat, defaultTimeFormat } from 'vince-core/constants/localization';

export function useFormatting () {
    const userStore = useUserStore();

    function formatDateTime (dateTime: string | undefined | null): string {
        const format = userStore.userInfo!.userSettings?.timeFormat || undefined;
        return dfFormatter(dateTime, format);
    }

    function formatDate (dateTime: string | undefined | null): string {
        const format = userStore.userInfo!.userSettings?.timeFormat || undefined;
        return dfFormatter(dateTime, format ? format.split(' ')[0] : defaultDateFormat);
    }

    function formatTime (dateTime: string | undefined | null): string {
        const format = userStore.userInfo!.userSettings?.timeFormat || undefined;
        return dfFormatter(dateTime, format ? format.split(' ')[1] : defaultTimeFormat);
    }

    function formatDateTimePassed (dateTime1: string | undefined | null, dateTime2: string | undefined | null = null): string {
        const locale = userStore.userInfo!.userSettings?.preferredLocale;
        return passedTimeFormatter(dateTime1, dateTime2, locale);
    }

    function formatDateTimeByRegion (dateTime: string | undefined | null): string {
        const format = userStore.userInfo!.userSettings?.timeFormat || undefined;
        const locale = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return dfFormatter(dateTime, format, locale);
    }

    return {
        formatTime,
        formatDateTime,
        formatDate,
        formatDateTimePassed,
        formatDateTimeByRegion
    };
}
